export const isAlcoholicProduct = (alcoholPercent?: string) => {
  return !!(alcoholPercent && !isNaN(+alcoholPercent) && +alcoholPercent > 0)
}
